<template>
    <v-card v-ripple
            class="my-5 px-2 clients-list-item">
        <v-card-title class="clients-list__img">
            <div v-bind:style="{ backgroundColor: avatarsColors[index % avatarsColors.length]}"
                 class="clients-list__img-inside">
                {{client.name[0]}}
            </div>
        </v-card-title>
        <v-card-title class="clients-list__title">{{client.name}}</v-card-title>
    </v-card>
</template>

<script>
    export default {
        name: "ClientsListItem",
        props: ['client', 'index', 'avatarsColors'],
        data: () =>
            ({
                show: true,
            })
    }
</script>

<style scoped>

</style>
